var _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgElipse = function SvgElipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 279,
    viewBox: "0 0 85 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 139.5,
    r: 127,
    stroke: "#FFF0E4",
    strokeWidth: 25
  })));
};

export default SvgElipse;